import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";
import "./footer.css";


//
const Footer = () => {
  return (
    <React.Fragment>
      
    <footer className="footer-main">
      <div className="page-wrap">
        <div className="footer-items">
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/products">Products</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>

          <div className="spacer"></div>
          <div className="social-links">
            <Link to="https://www.instagram.com/higorgeous_skincare">
              <FaInstagram />
            </Link>
            <Link to="http://tiktok.com/@higorgeous_cosmetics">
              <FaTiktok />
            </Link>
            <Link to="https://wa.me/2348054927205">
              <FaWhatsapp />
            </Link>
            {/* 
            <Link to="">
              <FaFacebook />
            </Link>*/}
          </div>
        </div>
      </div>
      <div className="page-wrap">
        <div className="line"></div>
      </div>
     <div className="page-wrap">
        <iframe style={{backgroundColor:"none"}} width="100%" height="80" frameBorder="no"  scrolling="no"  src="https://www.baibangma.com/higorgeous"></iframe>
      </div>
      <div className="page-wrap">
        <div className="flex flex-row-resp align-items-center">
          <span className="lowest-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/faq">FAQ</Link>
          </span>
          <span className="spacer"></span>
          <span className="copyright">
            &copy;2025 HiGorgeous. All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>
    </React.Fragment>
  );
};

export default Footer;
